import React, { forwardRef } from 'react';
import { ChevronDown } from 'lucide-react';
interface SelectOption {
  value: string;
  label: string;
}
interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  error?: string;
  helperText?: string;
  options: SelectOption[];
}
export const Select = forwardRef<HTMLSelectElement, SelectProps>(({
  className = '',
  label,
  error,
  helperText,
  options,
  ...props
}, ref) => {
  return <div className="w-full" data-id="element-766">
        {label && <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-767">
            {label}
            {props.required && <span className="text-red-500 ml-1" data-id="element-768">*</span>}
          </label>}
        <div className="relative" data-id="element-769">
          <select ref={ref} className={`w-full appearance-none rounded-lg border ${error ? 'border-red-500' : 'border-gray-300'} px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-greenback focus:border-transparent disabled:bg-gray-100 disabled:text-gray-500 ${className}`} {...props} data-id="element-770">
            {options.map(option => <option key={option.value} value={option.value} data-id="element-771">
                {option.label}
              </option>)}
          </select>
          <ChevronDown className="absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400 pointer-events-none" data-id="element-772" />
        </div>
        {helperText && !error && <p className="mt-1 text-xs text-gray-500" data-id="element-773">{helperText}</p>}
        {error && <p className="mt-1 text-xs text-red-500" data-id="element-774">{error}</p>}
      </div>;
});
Select.displayName = 'Select';